export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const FREQUENCY_CAP_MS = 3 * MS_PER_DAY;
export const LONG_SNOOZE_DAYS = 60;
export const MIN_QUIZ_QUESTIONS = 3;

/** The four phases `PopQuizModal` renders. Mirrors the `Phase` union in `types.ts`. */
export const POP_QUIZ_PHASE = {
    prompt: 'prompt',
    quiz: 'quiz',
    results: 'results',
    snoozed: 'snoozed',
} as const;
// Courses not accessed within this many days are considered too stale for a meaningful quiz.
export const STALE_COURSE_DAYS = 60;
